import { Util } from '@libs/utilities/util';

import { ISearchLinks, ISearchLinkUrlConfig } from '../../../data/search-links.interface';


/**------------------------------------------------------
 * TikTok Search Url
 */
export class TikTokSearch implements ISearchLinks {

	//** Configurations */
	private readonly TIKTOK_CONFIG: ISearchLinkUrlConfig = {
		home		: 'https://www.tiktok.com',
		login		: 'https://www.tiktok.com/login',
		search		: 'https://www.tiktok.com/search/video?q=[SEARCH]'
	};


	//** Home & Login */
	home() : string { return this.TIKTOK_CONFIG.home; }
	login(): string { return this.TIKTOK_CONFIG.login; }

	//** Search */
	search(searchQuery: string): string {

		//0 - if no search string existing then return main or home page
		if (Util.String.isEmpty(searchQuery)) return this.home();

		//1 - else return the url with search query
		return this.TIKTOK_CONFIG.search.replace('[SEARCH]', encodeURIComponent(Util.String.purifyWhitespaces(searchQuery)));
	}
}
